import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "tutinsapp_visitor_id";

const getVisitorId = () => {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = (crypto.randomUUID?.() || String(Date.now() + Math.random())).slice(0, 40);
    localStorage.setItem(KEY, id);
  }
  return id;
};

export const VisitTracker = () => {
  const { pathname } = useLocation();
  const last = useRef(null);

  useEffect(() => {
    if (pathname.startsWith("/admin") || last.current === pathname) return;
    last.current = pathname;
    axios
      .post(`${API}/track/visit`, {
        path: pathname,
        visitor_id: getVisitorId(),
        referrer: document.referrer || "direct",
      })
      .catch(() => {});
  }, [pathname]);

  return null;
};
